/**
 * Detect images and videos in Copilot markdown so the chat can show a gallery
 * or a media card instead of a raw URL.
 */

export const VIDEO_EXTENSION = /\.(mp4|webm|ogg|mov|m4v)(\?|$)/i

export const VIDEO_HOST =
  /(^|\.)((youtube\.com|youtu\.be|vimeo\.com|stream\.microsoft\.com)|(sharepoint\.com.*\/:v:\/))/i

export function isDirectVideoFile(url: string) {
  try {
    return VIDEO_EXTENSION.test(new URL(url).pathname)
  } catch {
    return VIDEO_EXTENSION.test(url)
  }
}

export function isVideoUrl(url: string) {
  if (!/^https:\/\//i.test(url || "")) return false
  if (isDirectVideoFile(url)) return true
  try {
    const host = new URL(url).hostname.replace(/^www\./, "")
    if (/^(youtube\.com|youtu\.be|vimeo\.com)$/i.test(host)) return true
    if (/stream\.microsoft\.com$/i.test(host)) return true
    if (/sharepoint\.com$/i.test(host) && /\/:v:\//i.test(url)) return true
  } catch {
    return false
  }
  return false
}

/** Allowlisted hosts that may be embedded as <video controls> (direct files only). */
export function canEmbedVideo(url: string) {
  return isDirectVideoFile(url) && /^https:\/\//i.test(url)
}

export function videoCardTitle(url: string, label?: string) {
  const named = (label || "").trim()
  if (named && !/^https?:\/\//i.test(named)) return named
  try {
    const parsed = new URL(url)
    const host = parsed.hostname.replace(/^www\./, "")
    if (/youtu\.?be/i.test(host)) return "YouTube video"
    if (/vimeo\.com/i.test(host)) return "Vimeo video"
    if (/stream\.microsoft\.com/i.test(host) || /\/:v:\//i.test(url)) {
      return "SharePoint / Stream video"
    }
    const file = decodeURIComponent(parsed.pathname.split("/").pop() || "")
    if (file) return file
    return host
  } catch {
    return "Video"
  }
}

export function mediaHostLabel(url: string) {
  try {
    return new URL(url).hostname.replace(/^www\./, "")
  } catch {
    return "source"
  }
}
